/*
 * Ajax Load More
 */
;(function($, window) {
    'use strict';

    var win = $(window);
    function getWindowHeight() {
        return window.innerHeight || document.documentElement.clientHeight;
    }

    function LoadMore(options) {
        this.options = $.extend({
            ajaxTarget: '.ajax-target',
            btnHolder: '.btn-holder',
            btnLoad: 'a.load-more',
            items: '.post',
            ajaxData: 'ajax=true',
            animSpeed: 300,
            loadingClass: 'loading',
            method: 'get',
            mode: 'click' // 'click', 'scroll'
        }, options);
        this.init();
    }
    LoadMore.prototype = {
        init: function() {
            if (this.options.holder) {
                this.findElements();
                this.attachEvents();
                this.makeCallback('onInit', this);
            }
        },
        findElements: function() {
            // find elements
            this.holder = $(this.options.holder);
            this.ajaxTarget = this.holder.find(this.options.ajaxTarget);
            this.btnLoad = this.holder.find(this.options.btnLoad);
            this.btnHolder = this.holder.find(this.options.btnHolder);
            if (!this.btnHolder.length) {
                this.btnHolder = this.btnLoad;
            }
        },
        attachEvents: function() {
            var self = this;

            if (!this.btnLoad.length) return;

            // handle events
            this.bindHandlers();
            this.btnLoad.on('click', this.onClick);
            if (this.options.mode === 'scroll') {
                // handle events
                win.on('load resize orientationchange refreshLoadMore', this.onResize)
                    .on('scroll', this.onScroll);

                // initial handler call
                this.onResize();
            }
        },
        onClick: function(e) {
            e.preventDefault();
            if (!this.isBusy) {
                this.loadNextPage();
            }
        },
        onResize: function() {
            this.recalculateOffsets();
            this.onScroll();
        },
        recalculateOffsets: function() {
            this.winHeight = getWindowHeight();
            this.targetBottom = this.ajaxTarget.offset().top + this.ajaxTarget.outerHeight(true);
        },
        onScroll: function() {
            if (!this.isBusy) {
                if (this.winHeight + win.scrollTop() > this.targetBottom) {
                    this.loadNextPage();
                }
            }
        },
        loadNextPage: function() {
            this.loadAjax({
                ajaxData: this.options.ajaxData,
                url: this.btnLoad.attr('href'),
                type: this.options.method || 'get'
            });
        },
        loadAjax: function(obj) {
            var self = this;
            this.isBusy = true;
            this.holder.addClass(this.options.loadingClass);
            if (this.ajaxRequest) {
                this.ajaxRequest.abort();
            }

            this.ajaxRequest = $.ajax({
                type: obj.type,
                url: obj.url,
                data: obj.ajaxData,
                success: function(data) {
                    self.ajaxLoaded(data);
                }
            });
        },
        ajaxLoaded: function(data) {
            // user function instead of default handler
            if ($.isFunction(this.options.customAjaxLoadHandler)) {
                this.options.customAjaxLoadHandler.call(this, data);
                return;
            }

            var self = this,
                newContent = jQuery('<div>', { html: data }),
                newItems = newContent.find(this.options.items).hide().appendTo(this.ajaxTarget),
                newBtnLoad = newContent.find(this.options.btnLoad),
                readyItemsCounter = 0, newItemsCount = newItems.length;

            this.makeCallback('onAjaxReady', newContent);

            if (newItemsCount) {
                this.imagesLoaded(newItems, function() {
                    newItems.stop().fadeIn(self.options.animSpeed, function() {
                        readyItemsCounter++;
                        if (readyItemsCounter === newItemsCount) {
                            self.makeCallback('onLoad', newItems);
                        }
                    });
                    ajaxComplete();
                });
            } else {
                ajaxComplete();
            }

            function ajaxComplete() {
                self.holder.removeClass(self.options.loadingClass);
                self.isBusy = false;
                self.makeCallback('onBeforeShow', newItems);
                if (self.options.mode === 'scroll' && newBtnLoad.length) {
                    self.onResize();
                }
            }

            if (newBtnLoad.length) {
                this.btnLoad.attr('href', newBtnLoad.attr('href'));
            } else {
                if (this.options.mode === 'scroll') {
                    win.off('load resize orientationchange refreshLoadMore', this.onResize).off('scroll', this.onScroll);
                }
                this.btnHolder.fadeOut(500);
            }
        },
        imagesLoaded: function(newItems, complete) {
            var self = this;
            if ($.isFunction(window.picturefill)) {
                picturefill();
            }
            setTimeout(function() {
                var newImages = newItems.find('img'),
                    imagesCount = newImages.length,
                    loadedCount = 0;

                if (imagesCount) {
                    newImages.each(function() {
                        var image = $(this);
                        $('<img />').on('load error', function() {
                            loadedCount++;
                            if (loadedCount === imagesCount) {
                                complete();
                            }
                        }).attr('src', image.attr('src'));
                    });

                } else {
                    complete();
                }
            }, 50);
        },
        bindHandlers: function() {
            var self = this;
            $.each(self, function(propName, propValue) {
                if (propName.indexOf('on') === 0 && $.isFunction(propValue)) {
                    self[propName] = function() {
                        return propValue.apply(self, arguments);
                    };
                }
            });
        },
        makeCallback: function(name) {
            var args;
            if (typeof this.options[name] === 'function') {
                args = Array.prototype.slice.call(arguments);
                args.shift();
                this.options[name].apply(this, args);
            }
        },
        destroy: function() {
            this.btnLoad.off('click', this.onClick);
            if (this.options.mode === 'scroll') {
                win.off('load resize orientationchange', this.onResize).off('scroll', this.onScroll);
            }
        }
    };

    // jQuery plugin interface
    $.fn.loadMore = function(options) {
        return this.each(function() {
            var params = $.extend({}, options, { holder: this }),
                instance = new LoadMore(params);
            $.data(this, 'LoadMore', instance);
        });
    };

    // module exports
    window.LoadMore = LoadMore;
}(jQuery, window));